import * as React from 'react'
import type { CSSProperties } from 'react'
import { cn } from '../lib'
import { designTokens } from '../lib/design-tokens'
import { typographyStyle } from '../lib/catalog'

const Label = React.forwardRef<HTMLLabelElement, React.LabelHTMLAttributes<HTMLLabelElement>>(
  ({ className, htmlFor, style, ...props }, ref) => {
    const tokenStyle: CSSProperties = {
      fontFamily: designTokens.typography.fontFamilies.primary,
      color: designTokens.colors.text.primary,
      ...typographyStyle(designTokens.typography.label),
    }

    return (
      <label
        ref={ref}
        htmlFor={htmlFor}
        className={cn('peer-disabled:cursor-not-allowed peer-disabled:opacity-70', className)}
        style={{ ...tokenStyle, ...style }}
        {...props}
      />
    )
  }
)
Label.displayName = 'Label'

export { Label }
